import { Model } from 'json-api-models';

import { Models, Schemas } from '../models.ts';
import { nullableDate } from '../utils/format.ts';

export class SubscriptionPayment extends Model<Schemas['subscriptionPayments'], Models> {
    get createdAtDate() {
        return nullableDate(this.createdAt);
    }

    get updatedAtDate() {
        return nullableDate(this.updatedAt);
    }

    get extendedUntilDate() {
        return nullableDate(this.extendedUntil);
    }

    get refundedAtDate() {
        return nullableDate(this.refundedAt);
    }

    get sourceLabel() {
        const source = this.attributes.source;

        if (!source) {
            return 'Unknown';
        }

        return {
            STRIPE: 'Stripe',
            APP_STORE: 'App Store',
            PLAY_STORE: 'Play Store',
            REFERRER: 'Referrer',
            REFEREE: 'Referee',
            COUPON: 'Coupon',
            JOURNEY_GRAD: 'Graduation Journey',
            ADMIN: 'Admin',
            UPGRADE: 'Upgrade',
        }[source];
    }
}
